import React, { useState } from 'react';
import { Box} from '@mui/material';
import ActionItems from '.././ActionItems/ActionItems';
import ActionItem from '.././ActionItems/ActionItem';
import ProgressSpinner from '../Common/ProgressSpinner';
import { initialSort } from '../ActionItems/actionItemTableConfig';
import SlideOver from '../Common/SlideOver';

interface ActionItem {
  description: string;
  due_date: string;
}

interface GlobalSearchResultsActionViewProps {
  searchData: {
    data: {
      data: {
        meetings: any[];
        action_items: ActionItem[];
      };
    };
  } | null;
}

const GlobalSearchActionView: React.FC<GlobalSearchResultsActionViewProps> = ({  searchData }) => {
    const [attendees, setAttendees] = useState<any[]>([]);
    const [openDialog, setOpenDialog] = useState<boolean>(false);
    const [actionItems, setActionItems] = useState<ActionItem[]>([]);
    const [selectedActionItem, setSelectedActionItem] = useState<ActionItem | null>(null);
    const [showSpinner, setShowSpinner] = useState<boolean>(false);
    const [isPreview, setIsPreview] = useState<boolean>(false);
    const [totalRecord, setTotalRecord] = useState(0);
    const [pageNumber, setPageNumber] = useState(1);
    const [pageSize, setPageSize] = useState(50);
    const [sort, setSort] = useState(initialSort);
    const [isActionItemValid, setIsActionItemValid] = useState(false);
    const [saveTrigger, setSaveTrigger] = useState(false);
      const [discardTrigger, setDiscardTrigger] = useState(false);
      const handleSave = () => setSaveTrigger(true);
      const handleDiscard = () => {
        (setDiscardTrigger(true), setOpenDialog(false));
      }

    const [filters, setFilters] = useState<{
        date: { start_time: string; end_time: string } | undefined;
        status: undefined | string;
    }>({
        date: undefined,
        status: "todo,in_progress",
    });

    React.useEffect(() => {
        if (searchData) {
            let actionItems = searchData.data?.data?.action_items || [];
            if (sort.sort_field) {
                actionItems = actionItems.sort((a: any, b: any) => {
                    const fieldA = a[sort.sort_field];
                    const fieldB = b[sort.sort_field];
                    if (sort.sort_order === "asc") {
                        return fieldA > fieldB ? 1 : -1;
                    }
                    return fieldA < fieldB ? 1 : -1;
                });
            }
            const startIdx = (pageNumber - 1) * pageSize;
            const paginatedItems = actionItems.slice(startIdx, startIdx + pageSize);
            setTotalRecord(actionItems.length)
            setActionItems(paginatedItems);
        }
    
        setShowSpinner(false);
    }, [searchData, pageNumber, pageSize, filters, sort]);

    const onPageChange = (value: number) => {
        setPageNumber(value);
    };

    const onFilter = (value: {
        date: { start_time: string; end_time: string } | undefined;
        status: undefined | string;
    }) => {
        setFilters(value);
        setPageNumber(1);
    };


    const onSort = (value: { sort_field: string; sort_order: string }) => {
        setSort(value as { sort_field: string; sort_order: "asc" | "desc" });
    };
    const handleActionItemSelection = (actionItem: any) => {
        setOpenDialog(true);
        setSelectedActionItem(actionItem);
        setAttendees([actionItem?.assignee]);
    };

    const handleActionItemPreview = (actionItem: any) => {
        setOpenDialog(true);
        setSelectedActionItem(actionItem);
        setAttendees([actionItem?.assignee]);
        setIsPreview(true);
    };

    const handleClose = () => {
        setOpenDialog(false);
        setSelectedActionItem(null);
        setIsPreview(false);
    };

    return (
        <>
            <Box
                id="actionItemsParent"
                className="flex flex-col justify-start items-start gap-6"
                style={{ marginTop: "-10px" }}
            >
                <Box className="actionItemsContent w-full">
                    <Box>
                        <Box sx={{ marginTop: "10px" }}>
                            <ActionItems
                                type="MY_ACTION_ITEMS"
                                isLoading={showSpinner} 
                                actionItems={actionItems}
                                totalRecord={totalRecord}
                                handleActionItemSelection={handleActionItemSelection}
                                handleActionItemPreview={handleActionItemPreview}
                                pageSize={pageSize}
                                onPageChange={onPageChange}
                                onSearch={()=>{}}
                                onFilter={onFilter}
                                onSort={onSort}
                                actionItemType="all"
                                onTypeChange={()=>{}}
                                onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                            />
                        </Box>
                    </Box>
                </Box>
            </Box>

            <SlideOver 
            isOpen={openDialog} 
            onClose={handleClose}
            showHeaderButtons={true}
            onSave={handleSave}
            onDiscard={handleDiscard}
            discard={selectedActionItem != null ? false : true}
            saveDisabled={!isActionItemValid}
            >
            <ActionItem
                        actionItemType="MY_ACTION_ITEMS"
                        selectedActionItem={selectedActionItem}
                        attendees={attendees}
                        isPreview={isPreview}
                        handleClose={handleClose}
                        saveTrigger={saveTrigger}
                        discardTrigger={discardTrigger}
                        resetSaveTrigger={() => setSaveTrigger(false)}
                        onValidityChange={setIsActionItemValid}
                        resetDiscardTrigger={() => setDiscardTrigger(false)}
                        isNewActionItem= {false}
                        openDialog={openDialog}
                    />
            </SlideOver>
            <ProgressSpinner showSpinner={showSpinner} />
        </>
    );
};

export default GlobalSearchActionView;
